/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import BoardListIcon from './BoardListIcon/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Header/Content/No/Title"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let taskBoardsListTypeValueData = fromData.useDataFormat({ viewPath,
context: 'task_boards_list',
path: 'type',
format: fromHelpers.getText,
})
  return (<React.Fragment
>
<div
  data-testid="Title.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-5P3Cr': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--mt-2-5P3Cr': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<BoardListIcon
  viewPath={`${viewPath}/BoardListIcon`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="normal"
 marginLeft={dtSpaceXs}
 data="task_boards_list.type"
 format="helpers.js getText"
 text={taskBoardsListTypeValueData}
/>
</div>
{children}
</React.Fragment>)
}